import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { ChevronDown, LifeBuoy } from 'lucide-react';
import { HelpLinks } from './shared/HelpLinks';
import { MorphPanel } from './shared/MorphPanel';
import { eventBus, useEventSubscribe } from '../events';
// Help hub pinned to the map corner. Replaces the old auto-advancing
// "Directions" carousel: instead of describing the UI in prose, it offers the
// few things a stuck user actually wants — the layer guide, tutorials, and a
// way to reach a human. At rest it's a lifebuoy puck (hover-expands to its
// label); a click opens the hub. Always one click away.
export const DirectionsPanel = () => {
    const [isExpanded, setIsExpanded] = useState(false);
    const toggle = () => {
        setIsExpanded((prev) => {
            if (!prev)
                eventBus.emit('overlay:opened', { id: 'help' });
            return !prev;
        });
    };
    // Close when the peer top-right overlay (Map Options) opens.
    useEventSubscribe('overlay:opened', (p) => {
        if (p.id !== 'help')
            setIsExpanded(false);
    }, []);
    return (_jsx("div", { className: `absolute ${isExpanded ? 'z-[60]' : 'z-[55]'} md:top-20 md:right-4 max-md:top-4 max-md:right-4`, "data-tour": "help-hub", children: _jsxs(MorphPanel, { collapsed: !isExpanded, onToggle: toggle, icon: _jsx(LifeBuoy, { size: 18, style: { color: 'var(--sand)' } }), label: "Help & Support", anchor: "top-right", expandedWidth: 288, children: [_jsxs("div", { className: "p-3 border-b flex items-center justify-between cursor-pointer flex-shrink-0", style: { borderColor: 'var(--pewter)' }, onClick: () => setIsExpanded(false), children: [_jsxs("div", { className: "flex items-center gap-2", children: [_jsx(LifeBuoy, { size: 15, style: { color: 'var(--sand)' } }), _jsx("span", { className: "font-heading text-sm font-semibold", style: { color: 'var(--sand)' }, children: "Help & Support" })] }), _jsx(ChevronDown, { size: 16 })] }), _jsxs("div", { className: "p-3 space-y-2", children: [_jsx("p", { className: "text-xs px-1 pb-1", style: { color: 'var(--dew)' }, children: "New here, or want a refresher? We're here to help." }), _jsx(HelpLinks, { onClose: () => setIsExpanded(false) })] })] }) }));
};
